angular.module('unergie.main')
.factory('NotificationService', ($state, $window, ModalService, webNotification, UserNotificationService) => {
    const muteConf = {}

    Object.keys(localStorage).forEach((key) => {
        if (key.startsWith('MUTE_NOTIF_')) {
            muteConf[key.replace('MUTE_NOTIF_', '')] = localStorage[key]
        }
    })

    const muteNotif = (event, until) => {
        muteConf[event] = until
        localStorage[`MUTE_NOTIF_${event}`] = until
        console.log(`"${event}" events muted until`, until)
    }

    const showNotif = function (params) {
        let hideNotif
        const showIt = !muteConf[params.type] || moment(muteConf[params.type]).isBefore(moment())
        const options = {
            body: params.body,
            icon: `/images/assets/img/${params.icon || 'plum.ico'}`,
            tag: `${params.title}_${params.body}`,
            onClick() {
                if (params.url) {
                    $window.open(params.url, '_blank')
                } else if (params.state) {
                    $state.go(params.state, params.stateParams)
                } else if (params.result) {
                    ModalService.openModal({ type: 'resultModal', size: 'lg' }, {
                        result: {
                            processed: params.result.processed,
                            errors: params.result.errors,
                        },
                    })
                } else if (params.modal) {
                    ModalService.openModal(params.modal, params.modal.payload)
                }
                if (hideNotif) {
                    return hideNotif()
                }
            },
            autoClose: params.delay || 4000,
        }
        if (params.sound && showIt) {
            const sound = new Audio(`/sounds/${params.sound}.mp3`)
            sound.play()
        }
        const callback = function (error, hide) {
            hideNotif = hide
            if (error) {
                return window.alert(`Unable to show notification: ${error.message}`)
            }
        }

        UserNotificationService.addNotif({
            type: 'notif',
            msg: `${params.title} : ${params.body}`,
            url: params.url,
            state: params.state,
            result: params.result,
            modal: params.modal,
            eventType: params.type,
        })

        if (showIt) {
            return webNotification.showNotification(params.title, options, callback)
        }
    }

    return {
        showNotif,
        muteNotif,
    }
})
